import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClipboardService } from 'src/app/shared/clipboard.service';

export interface ClipboardDialogData {
  title: string;
  copyText: string;
}

@Component({
  selector: 'app-clipboard-dialog',
  templateUrl: './clipboard-dialog.component.html',
  styleUrls: ['./clipboard-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClipboardDialogComponent implements OnInit, AfterViewInit {
  settings: ClipboardDialogData = {
    title: 'Copy to Clipboard',
    copyText: '',
  };

  get rowCount(): number {
    const rows = this.settings.copyText.split(/\r?\n/);
    return rows.length + 1;
  }

  @ViewChild('copyField', { static: true })
  copyField: ElementRef<HTMLTextAreaElement>;

  constructor(
    public dialogRef: MatDialogRef<ClipboardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ClipboardDialogData,
    private clipboardService: ClipboardService,
  ) {
    this.settings = {
      ...this.settings,
      ...data,
    };
  }

  ngOnInit() {}

  ngAfterViewInit() {
    const input = this.copyField.nativeElement;
    input.focus();
    input.select();
  }

  handleCopyClick() {
    const copied = this.clipboardService.copyInputFieldValue(this.copyField.nativeElement);
    this.close(copied);
  }

  handleCancelClick() {
    this.close(false);
  }

  close(copied: boolean) {
    this.dialogRef.close(copied);
  }
}
